import Division from './Division'
import ProjectReportedValues from './ProjectReportedValues'
export default class LuReportedType {
  constructor(objIn = {}) {
    const defaults = {
      //ID is required
      ID: 0,
      ReportedType: null,
      DivisionID: null,
      IsActive: null,
      SortOrder: null,
    }
    let obj = {}
    Object.assign(obj, defaults, objIn)
    this.ID = obj.ID
    this.ReportedType = obj.ReportedType
    this.DivisionID = obj.DivisionID
    this.IsActive = obj.IsActive
    this.SortOrder = obj.SortOrder

    this.Division = new Division(obj.Division || {})
    this.ProjectReportedValues = []
    if (obj.ProjectReportedValues) {
      obj.ProjectReportedValues.forEach((item) => {
        this.ProjectReportedValues.push(new ProjectReportedValues(item))
      })
    }
  }
  removeRelated() {
    let obj = Object.assign({}, this)
    obj.Division = null
    obj.ProjectReportedValues = []
    if (this.ProjectReportedValues) {
      this.ProjectReportedValues.forEach((item) => {
        obj.ProjectReportedValues.push(item.removeRelated())
      })
    }
    return obj
  }
  root() {
    let obj = Object.assign({}, this)
    obj.Division = null
    obj.ProjectReportedValues = null
    return obj
  }
}
